<script setup lang="ts">
import { computed, ref } from 'vue';
import { directive as clickAway } from 'vue3-click-away';
import { Direction } from '@enums/direction.ts';

const {
  panelClass = '',
  triggerClass = '',
  direction = Direction.DOWN,
} = defineProps<{
  panelClass?: string,
  triggerClass?: string,
  direction?: Direction,
}>();

defineOptions({ directives: { clickAway } });

const isVisible = ref<boolean>(false);

const toggleTooltip = (): void => {
  isVisible.value = !isVisible.value;
};

const closeTooltip = (): void => {
  isVisible.value = false;
};

const directionVariant = computed<string>(() => direction.toLowerCase());
</script>

<template>
  <div
    class="v-tooltip-click"
    :class="`v-tooltip-click--${directionVariant}`"
  >
    <div
      class="v-tooltip-click__trigger"
      :class="triggerClass"
      @click.prevent.stop="toggleTooltip"
    >
      <slot name="trigger" />
    </div>

    <div
      v-show="isVisible"
      v-click-away="closeTooltip"
      class="v-tooltip-click__panel"
      :class="[
        `v-tooltip-click__panel--${directionVariant}`,
        panelClass,
      ]"
    >
      <slot name="panel" :close="closeTooltip" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins/rem' as *;

.v-tooltip-click {
  position: relative;

  &--right {
    display: flex;
  }

  &__panel {
    z-index: 10;
    position: absolute;
    transition: all 0.3s;
    border: 1px solid $colorGray;
    border-radius: toRem(4);
    box-shadow: 0 toRem(4) toRem(8) 0 rgb(0 0 0 / 0.25);
    background-color: $colorWhite;
    padding: toRem(16);
    white-space: nowrap;

    &--right {
      top: 0;
      left: 100%;
    }

    &--up {
      bottom: toRem(48);
    }
  }
}
</style>
